// fields can be renamed by editing here, this ignores what the normal filters/mmy apps produce for field titles
// fields can be enabled by removing display:none or changing to display:block

document.writeln("<div class='row dynamic-dropdown elic_hero'>");
document.writeln("	<div class='col cols1of6 hl-wrap'>");
document.writeln("      <div class='hl-main'>Find Your<br><em>Perfect Kit</em></div>");
document.writeln("      <div class='hl-sub'>Select your vehicle.<br>See every kit that fits.</div>");
document.writeln("    </div>");
document.writeln("		<form name='myform' id='myForm' class='col cols3of6 elic_sel-card'>");
document.writeln("			<div class='row'>");

document.writeln("			<div class='col cols1of3 form-field form-options'>");
document.writeln("			<div class=' form-field-select-wrapper'>");
document.writeln("				<select name='optone2' id='makeSel' size='1' class='form-field-input form-field-select form-field-filled'>");
document.writeln("					<option value='' selected='selected'>Select Make</option>");
document.writeln("				</select>");
document.writeln("				<label for='makeSel' class='form-field-title'>Make</label>");
document.writeln("				<svg aria-hidden='true' focusable='false' role='presentation' width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'>");
document.writeln("					<path class='icon-chevron-down-left' d='M4 4.5L7 1.5' stroke='currentColor' stroke-width='1.25' stroke-linecap='square'></path>");
document.writeln("					<path class='icon-chevron-down-right' d='M4 4.5L1 1.5' stroke='currentColor' stroke-width='1.25' stroke-linecap='square'></path>");
document.writeln("				</svg>");
document.writeln("			</div>");
document.writeln("			</div>");

document.writeln("			<div class='col cols1of3 form-field form-options'>");
document.writeln("			<div class=' form-field-select-wrapper'>");
document.writeln("				<select name='opttwo2' id='ModelSel' size='1' class='form-field-input form-field-select form-field-filled'>");
document.writeln("					<option value='' selected='selected'>Select Model</option>");
document.writeln("				</select>");
document.writeln("				<label for='ModelSel' class='form-field-title'>Model</label>");
document.writeln("				<svg aria-hidden='true' focusable='false' role='presentation' width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'>");
document.writeln("					<path class='icon-chevron-down-left' d='M4 4.5L7 1.5' stroke='currentColor' stroke-width='1.25' stroke-linecap='square'></path>");
document.writeln("					<path class='icon-chevron-down-right' d='M4 4.5L1 1.5' stroke='currentColor' stroke-width='1.25' stroke-linecap='square'></path>");
document.writeln("				</svg>");
document.writeln("			</div>");
document.writeln("			</div>");

document.writeln("			<div class='col cols1of3 form-field form-options'>");
document.writeln("			<div class=' form-field-select-wrapper'>");
document.writeln("				<select name='optthree2' id='yearSel' size='1' class='form-field-input form-field-select form-field-filled'>");
document.writeln("					<option value='' selected='selected'>Select Year</option>");
document.writeln("				</select>");
document.writeln("				<label for='yearSel' class='form-field-title'>Year</label>");
document.writeln("				<svg aria-hidden='true' focusable='false' role='presentation' width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'>");
document.writeln("					<path class='icon-chevron-down-left' d='M4 4.5L7 1.5' stroke='currentColor' stroke-width='1.25' stroke-linecap='square'></path>");
document.writeln("					<path class='icon-chevron-down-right' d='M4 4.5L1 1.5' stroke='currentColor' stroke-width='1.25' stroke-linecap='square'></path>");
document.writeln("				</svg>");
document.writeln("			</div>");
document.writeln("			</div>");

document.writeln("			<div class='col cols1of1' style='display:none;'>");
document.writeln("				<select name='optfour2' id='subModelSel' size='1'>");
document.writeln("					<option value='' selected='selected'>Select Sub-Model</option>");
document.writeln("				</select>");
document.writeln("			</div>");

document.writeln("			<div class='col cols1of1 form-field form-options' style='display:none;'>");
document.writeln("			<div class=' form-field-select-wrapper'>");
document.writeln("				<select name='optone' id='level1Sel' size='1' class='form-field-input form-field-select form-field-filled'>");
document.writeln("					<option value='' selected='selected'>Select Brand</option>");
document.writeln("				</select>");
document.writeln("				<label for='level1Sel' class='form-field-title'>Brand</label>");
document.writeln("				<svg aria-hidden='true' focusable='false' role='presentation' width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'>");
document.writeln("					<path class='icon-chevron-down-left' d='M4 4.5L7 1.5' stroke='currentColor' stroke-width='1.25' stroke-linecap='square'></path>");
document.writeln("					<path class='icon-chevron-down-right' d='M4 4.5L1 1.5' stroke='currentColor' stroke-width='1.25' stroke-linecap='square'></path>");
document.writeln("				</svg>");
document.writeln("			</div>");
document.writeln("			</div>");

document.writeln("			<div class='col cols1of1' style='display:none;'>");
document.writeln("				<select name='opttwo' id='level2Sel' size='1'>");
document.writeln("					<option value='' selected='selected'>Select Level 2</option>");
document.writeln("				</select>");
document.writeln("			</div>");
document.writeln("			<div class='col cols1of1' style='display:none;'>");
document.writeln("				<select name='optthree' id='level3Sel' size='1'>");
document.writeln("					<option value='' selected='selected'>Select Level 3</option>");
document.writeln("				</select>");
document.writeln("			</div>");
document.writeln("			<div class='col cols1of1' style='display:none;'>");
document.writeln("				<select name='optfour' id='level4Sel' size='1'>");
document.writeln("					<option value='' selected='selected'>Select Level 4</option>");
document.writeln("				</select>");
document.writeln("			</div>");
document.writeln("			<div class='col cols1of1' style='display:none;'>");
document.writeln("				<select name='optfive' id='level5Sel' size='1'>");
document.writeln("					<option value='' selected='selected'>Select Level 5</option>");
document.writeln("				</select>");
document.writeln("			</div>");
document.writeln("			<div class='col cols1of1' style='display:none;'>");
document.writeln("				<select name='optsix' id='level6Sel' size='1'>");
document.writeln("					<option value='' selected='selected'>Select Level 6</option>");
document.writeln("				</select>");
document.writeln("			</div>");

document.writeln("			<div class='col cols1of1'>");
document.writeln("				<a class='button-primary mdc-ripple-surface mdc-ripple-upgraded' style='display:flex;align-items:center;justify-content:center;width:100%;color:#FFF!Important;' href='javascript:window.location.assign(buildUrl_mmy());'>");
document.writeln("              	<svg aria-hidden='true' focusable='false' role='presentation' xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 20 21'><path fill='currentColor' fill-rule='evenodd' d='M12.514 14.906a8.264 8.264 0 0 1-4.322 1.21C3.668 16.116 0 12.513 0 8.07 0 3.626 3.668.023 8.192.023c4.525 0 8.193 3.603 8.193 8.047 0 2.033-.769 3.89-2.035 5.307l4.999 5.552-1.775 1.597-5.06-5.62zm-4.322-.843c3.37 0 6.102-2.684 6.102-5.993 0-3.31-2.732-5.994-6.102-5.994S2.09 4.76 2.09 8.07c0 3.31 2.732 5.993 6.102 5.993z'></path></svg>&nbsp; SEARCH");
document.writeln("            	</a>");
document.writeln("			</div>");

document.writeln("			</div>");
document.writeln("		</form>");
document.writeln("		<div class='col cols2of6 quote-nudge'>");
document.writeln("      	<div class='qn-label'>Also Available</div>");
document.writeln("      	<div class='qn-text'>Need something <em>specific</em> or can't find your fitment?</div>");
document.writeln("      	<p><a class='qn-link' href='/pages/custom-suspension-quote'>Get a Custom Suspension Quote</a></p>");
document.writeln("      	<p><a class='qn-link' href='/pages/aftermarket-replacement-parts-accessories'>Get a Custom Parts Quote</a></p>");
document.writeln("		</div>");
document.writeln("</div>");

addLoadEvent(function() {
	var loaded = 0;
	
	var makeSel = document.getElementById("makeSel"), ModelSel = document.getElementById("ModelSel"), yearSel = document.getElementById("yearSel"), subModelSel = document.getElementById("subModelSel");
  
	for (var make in makeObject) {
		var make_display = make.replace(/_/g, " ");
		makeSel.options[makeSel.options.length] = new Option(make_display, make);
	}
	
	makeSel.onchange = function() {
		ModelSel.length = 1;
		yearSel.length = 1; 
		subModelSel.length = 1; 
		if (this.selectedIndex < 1) return; // done   
		for (var model in makeObject[this.value]) {
			var model_display = model.replace(/_/g, " ");
			var model_display = model.replace(/!/g, "/");
			ModelSel.options[ModelSel.options.length] = new Option(model_display, model);
		}
		if (loaded == 0 && makeSel.value == getCookie("makesel")) {
			var i;
			for (i = 0; i < ModelSel.length; i++) {
				if (getCookie("modelsel") == ModelSel.options[i].value) {
					ModelSel.value = getCookie("modelsel");
				}
			}
  		}
	}
		
	ModelSel.onchange = function() {
		yearSel.length = 1;
		subModelSel.length = 1;
		if (this.selectedIndex < 1) return; // done   
		for (var year in makeObject[makeSel.value][this.value]) {
			yearSel.options[yearSel.options.length] = new Option(year, year);
		}
		if (loaded == 0 && makeSel.value == getCookie("makesel") && ModelSel.value == getCookie("modelsel")) {
			var i;
			for (i = 0; i < yearSel.length; i++) {
				if (getCookie("yearsel") == yearSel.options[i].value) {
					yearSel.value = getCookie("yearsel");
				}
			}
  		}
	}
	
	yearSel.onchange = function() {
		subModelSel.length = 1;
		if (this.selectedIndex < 1) return; // done   
		var submodels = makeObject[makeSel.value][ModelSel.value][yearSel.value];
		for (var i = 0; i < submodels.length; i++) {
			subModelSel.options[subModelSel.options.length] = new Option(submodels[i],submodels[i]);
		}
      	if (loaded == 0 && makeSel.value == getCookie("makesel") && ModelSel.value == getCookie("modelsel") && yearSel.value == getCookie("yearsel")) {
			var i;
			for (i = 0; i < subModelSel.length; i++) {
				if (getCookie("submodelsel") == subModelSel.options[i].value) {
					subModelSel.value = getCookie("submodelsel");
				}
			}
  		}
	}
    

	var i;
	for (i = 0; i < makeSel.length; i++) {
		if (getCookie("makesel") == makeSel.options[i].value) {
			makeSel.value = getCookie("makesel");
		}
	}
  
    makeSel.onchange();
    ModelSel.onchange();
    yearSel.onchange();
	
	
		var level1Sel = document.getElementById("level1Sel");
	var level2Sel = document.getElementById("level2Sel");
	var level3Sel = document.getElementById("level3Sel");
	var level4Sel = document.getElementById("level4Sel");
	var level5Sel = document.getElementById("level5Sel");
	var level6Sel = document.getElementById("level6Sel");
  
	for (var level1 in level1Object) {
		var level1_display = level1.replace(/_/g, " ");
		level1Sel.options[level1Sel.options.length] = new Option(level1_display, level1);
	}
	
	level1Sel.onchange = function() {
		level2Sel.length = 1;
		level3Sel.length = 1;
		level4Sel.length = 1;
		level5Sel.length = 1;
		level6Sel.length = 1;
		if (this.selectedIndex < 1) return; // done   
		for (var level2 in level1Object[this.value]) {
			var level2_display = level2.replace(/_/g, " ");
			var level2_display = level2.replace(/!/g, "/");
			level2Sel.options[level2Sel.options.length] = new Option(level2_display, level2);
		}
		if (loaded == 0 && level1Sel.value == getCookie("level1sel")) {
			var i;
			for (i = 0; i < level2Sel.length; i++) {
				if (getCookie("level2sel") == level2Sel.options[i].value) {
					level2Sel.value = getCookie("level2sel");
				}
			}
  		}
	}

	level2Sel.onchange = function() {
		level3Sel.length = 1;
		level4Sel.length = 1;
		level5Sel.length = 1;
		level6Sel.length = 1;
		if (this.selectedIndex < 1) return; // done   
		for (var level3 in level1Object[level1Sel.value][this.value]) {
			var level3_display = level3.replace(/_/g, " ");
			var level3_display = level3.replace(/!/g, "/");
			level3Sel.options[level3Sel.options.length] = new Option(level3_display, level3);
		}
		if (loaded == 0 && level1Sel.value == getCookie("level1sel") && level2Sel.value == getCookie("level2sel")) {
			var i;
			for (i = 0; i < level3Sel.length; i++) {
				if (getCookie("level3sel") == level3Sel.options[i].value) {
					level3Sel.value = getCookie("level3sel");
				}
			}
  		}
	}
	
	level3Sel.onchange = function() {
		level4Sel.length = 1;
		level5Sel.length = 1;
		level6Sel.length = 1;
		if (this.selectedIndex < 1) return; // done   
		for (var level4 in level1Object[level1Sel.value][level2Sel.value][this.value]) {
			var level4_display = level4.replace(/_/g, " ");
			var level4_display = level4.replace(/!/g, "/");
			level4Sel.options[level4Sel.options.length] = new Option(level4_display, level4);
		}
		if (loaded == 0 && level1Sel.value == getCookie("level1sel") && level2Sel.value == getCookie("level2sel") && level3Sel.value == getCookie("level3sel")) {
			var i;
			for (i = 0; i < level4Sel.length; i++) {
				if (getCookie("level4sel") == level4Sel.options[i].value) {
					level4Sel.value = getCookie("level4sel");
				}
			}
  		}
	}
	
	level4Sel.onchange = function() {
		level5Sel.length = 1;
		level6Sel.length = 1;
		if (this.selectedIndex < 1) return; // done   
		for (var level5 in level1Object[level1Sel.value][level2Sel.value][level3Sel.value][this.value]) {
			var level5_display = level5.replace(/_/g, " ");
			var level5_display = level5.replace(/!/g, "/");
			level5Sel.options[level5Sel.options.length] = new Option(level5_display, level5);
		}
		if (loaded == 0 && level1Sel.value == getCookie("level1sel") && level2Sel.value == getCookie("level2sel") && level3Sel.value == getCookie("level3sel") && level4Sel.value == getCookie("level4sel")) {
			var i;
			for (i = 0; i < level5Sel.length; i++) {
				if (getCookie("level5sel") == level5Sel.options[i].value) {
					level5Sel.value = getCookie("level5sel");
				}
			}
  		}
	}
	
	level5Sel.onchange = function() {
		level6Sel.length = 1;
		if (this.selectedIndex < 1) return; // done   
		for (var level6 in level1Object[level1Sel.value][level2Sel.value][level3Sel.value][level4Sel.value][this.value]) {
			var level6_display = level6.replace(/_/g, " ");
			var level6_display = level6.replace(/!/g, "/");
			level6Sel.options[level6Sel.options.length] = new Option(level6_display, level6);
		}
		if (loaded == 0 && level1Sel.value == getCookie("level1sel") && level2Sel.value == getCookie("level2sel") && level3Sel.value == getCookie("level3sel") && level4Sel.value == getCookie("level4sel") && level5Sel.value == getCookie("level5sel")) {
			var i;
			for (i = 0; i < level6Sel.length; i++) {
				if (getCookie("level6sel") == level6Sel.options[i].value) {
					level6Sel.value = getCookie("level6sel");
				}
			}
  		}
	}


	var i;
	for (i = 0; i < level1Sel.length; i++) {
		if (getCookie("level1sel") == level1Sel.options[i].value) {
			level1Sel.value = getCookie("level1sel");
		}
	}
  
    level1Sel.onchange();
    level2Sel.onchange();
    level3Sel.onchange();
	level4Sel.onchange();
	level5Sel.onchange();
	
    loaded = 1;
});

function buildUrl_mmy() {
	document.cookie = "makesel=" + document.querySelector('#makeSel').value + "; path=/";
	document.cookie = "modelsel=" + document.querySelector('#ModelSel').value + "; path=/";
	document.cookie = "yearsel=" + document.querySelector('#yearSel').value + "; path=/";
	document.cookie = "submodelsel=" + document.querySelector('#subModelSel').value + "; path=/";
	var make = document.querySelector('#makeSel').value;
	var model = document.querySelector('#ModelSel').value;
	var year = document.querySelector('#yearSel').value;
	var submodel = document.querySelector('#subModelSel').value;
	var comma = ", ";
	document.cookie = "level1sel=" + document.querySelector('#level1Sel').value + "; path=/";
	document.cookie = "level2sel=" + document.querySelector('#level2Sel').value + "; path=/";
	document.cookie = "level3sel=" + document.querySelector('#level3Sel').value + "; path=/";
	document.cookie = "level4sel=" + document.querySelector('#level4Sel').value + "; path=/";
	document.cookie = "level5sel=" + document.querySelector('#level5Sel').value + "; path=/";
	document.cookie = "level6sel=" + document.querySelector('#level6Sel').value + "; path=/";
	var level1 = document.querySelector('#level1Sel').value;
	var level2 = document.querySelector('#level2Sel').value;
	var level3 = document.querySelector('#level3Sel').value;
	var level4 = document.querySelector('#level4Sel').value;
	var level5 = document.querySelector('#level5Sel').value;
	var level6 = document.querySelector('#level6Sel').value;
	
  if (level1.length != 0) {
   	 var level1 = level1 + comma
  }
  if (level2.length != 0) {
   	 var level2 = level2 + comma
  }
  if (level3.length != 0) {
   	 var level3 = level3 + comma
  }
  if (level4.length != 0) {
   	 var level4 = level4 + comma
  }
  if (level5.length != 0) {
   	 var level5 = level5 + comma
  }
  if (level6.length != 0) {
   	 var level6 = level6 + comma
  }
  if (make.length != 0) {
   	 var make = make + comma
  }
  if (model.length != 0) {
   	 var model = model + comma
  }
  if (year.length != 0) {
   	 var year = year + comma
  }
  if (submodel.length != 0) {
   	 var submodel = submodel + comma
  }
  	var url = "/search?type=product&q=" + level1 + level2 + level3 + level4 + level5 + level6 + make + model + year + submodel +"Coilover";
    url = url.replace(/_/g, "&");
	return url;
}

function addLoadEvent(func) {
  var oldonload = window.onload;
  if (typeof window.onload != 'function') {
    window.onload = func;
  } else {
    window.onload = function() {
      if (oldonload) {
        oldonload();
      }
      func();
    }
  }
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
} 

